// extracted by mini-css-extract-plugin
export default {"checkboxSwitch":"WMZGzDC1XvRy60o8aEqbbA==","checkboxSwitchLabel":"snjosup5UIrT3YUOSE5Wmg==","checkboxSwitchLabelContainer":"yOifG4rkCcdKtOzw18B4xA=="};